class Usage {

  static id = 0x12;

  static type = 'Usage';
}

export default Usage;
